/** Hidden /admin/* routes — matched before Lockbox entered/session routing. */

const ADMIN_FINANCE = '/admin/finance';
const ADMIN_GROUPS = '/admin/groups';

function normalizePathname(pathname) {
  if (!pathname || pathname === '/') return pathname || '/';
  return pathname.replace(/\/+$/, '') || '/';
}

export function isAdminFinanceRoute(pathname) {
  return normalizePathname(pathname) === ADMIN_FINANCE;
}

export function isAdminGroupsRoute(pathname) {
  return normalizePathname(pathname) === ADMIN_GROUPS;
}

export function isAdminRoute(pathname) {
  const path = normalizePathname(pathname);
  return path === ADMIN_FINANCE || path === ADMIN_GROUPS;
}

export function adminRouteKind(pathname) {
  if (isAdminFinanceRoute(pathname)) return 'finance';
  if (isAdminGroupsRoute(pathname)) return 'groups';
  return null;
}
